import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Determines whether the provided context contains mixed dressing details.
 */
export const checkIfHasMixedDressingDetails: Guard = function (args): boolean {
  const { context } = args;
  const { mixedDressingDetails } = context;

  return mixedDressingDetails.length > 0;
};
